import { render, staticRenderFns } from "./classStudent.vue?vue&type=template&id=cf3b8da0&scoped=true"
import script from "./classStudent.vue?vue&type=script&lang=js"
export * from "./classStudent.vue?vue&type=script&lang=js"
import style0 from "./classStudent.vue?vue&type=style&index=0&id=cf3b8da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3b8da0",
  null
  
)

export default component.exports